import * as React from 'react';

interface Props {
    isActive?: boolean;
    tkey: string;
    label: string;
    onItemClick?: (tkey: string) => void;
    className: string;
    inactiveNavCalloutNode?: React.ReactNode;
    activeNavCalloutNode?: React.ReactNode;
}

export default class TabListNavItem extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onItemClick, tkey } = this.props;

        evt.stopPropagation();

        if (onItemClick) {
            onItemClick(tkey);
        }
    };

    renderCalloutNode = (): React.ReactNode => {
        const { isActive, activeNavCalloutNode, inactiveNavCalloutNode } = this.props;

        const calloutNode: React.ReactNode = isActive ? activeNavCalloutNode : inactiveNavCalloutNode;

        if (!calloutNode) {
            return null;
        }

        return <span className="ddbc-tab-list__nav-item-callout">{calloutNode}</span>;
    };

    render() {
        const { label, isActive, className } = this.props;

        let classNames: Array<string> = [className, 'ddbc-tab-list__nav-item'];
        if (isActive) {
            classNames = [...classNames, 'ddbc-tab-list__nav-item--is-active'];
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                <span className="ddbc-tab-list__nav-item-label">{label}</span>
                {this.renderCalloutNode()}
            </div>
        );
    }
}
